import { PersonType } from './../../../../models/person-type.model';
import { Component, OnInit, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-physical-person-form',
    templateUrl: './physical-person-form.component.html',
    styleUrls: ['./physical-person-form.component.scss']
})
export class PhysicalPersonFormComponent implements OnInit, AfterViewInit {

    @Input()
    formGroup: UntypedFormGroup;

    @Input()
    personType: PersonType;

    constructor(
        private utilsService: UtilsService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        // Vacío por ahora
    }

    ngAfterViewInit(): void {
        // Listener para cambio de tipo de documento
        if (this.formGroup.controls.tipoDocumento) {
            this.formGroup.controls.tipoDocumento.valueChanges.subscribe(newValue => {
                this.updateValidators(newValue);
                
                // Limpiar el campo que no corresponde
                if (newValue === 'DNI') {
                    this.formGroup.controls.pasaporte?.setValue(undefined, { emitEvent: false });
                } else if (newValue === 'PASAPORTE') {
                    this.formGroup.controls.dni?.setValue(undefined, { emitEvent: false });
                }
            });
        }
        
        this.cdr.detectChanges();
    }

    updateValidators(tipoDocumento: 'DNI' | 'PASAPORTE') {
        if (tipoDocumento === 'DNI') {
            this.formGroup.controls.dni?.setValidators([
                Validators.required, 
                Validators.minLength(8), 
                Validators.maxLength(8), 
                this.utilsService.numberFormValidator
            ]);
            this.formGroup.controls.pasaporte?.setValidators([]);
        } else if (tipoDocumento === 'PASAPORTE') {
            this.formGroup.controls.dni?.setValidators([]);
            this.formGroup.controls.pasaporte?.setValidators([
                Validators.required, 
                Validators.minLength(6), 
                Validators.maxLength(20)
            ]);
        }
        
        this.formGroup.controls.dni?.updateValueAndValidity({ emitEvent: false });
        this.formGroup.controls.pasaporte?.updateValueAndValidity({ emitEvent: false });
    }
}